import "core-js/modules/es.iterator.constructor.js";
import "core-js/modules/es.iterator.filter.js";
import "core-js/modules/es.iterator.map.js";
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, mergeProps as _mergeProps, renderSlot as _renderSlot, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
import { saveColumnsConfig, clearColumnsConfig, readColumnsConfig, getDataIndexKey } from './configStore.js';
import { Table as ATable } from 'ant-design-vue';
import { computed, nextTick, onMounted, ref, unref, watch } from 'vue';
import { SettingOutlined, ClearOutlined } from '@ant-design/icons-vue';
import TableColumnConfig from './tableColumnConfig.vue';
const __default__ = {
  name: 'XTable'
};
export default /*@__PURE__*/Object.assign(__default__, {
  props: {
    // 列配置
    columns: {
      type: Array,
      default: () => []
    },
    // 本地配置存储键名
    configKey: {
      type: String,
      default: ''
    }
  },
  emits: ['row-click', 'row-dblclick', 'row-contextmenu', 'row-mouseenter', 'row-mouseleave', 'row-mouseenter', 'row-mouseleave'],
  setup(__props, {
    expose: __expose,
    emit: __emit
  }) {
    const containerRef = ref();
    const tableRef = ref();
    const showConfigModal = ref(false);
    // 列配置
    /*
    {
        title: 'Age',
        dataIndex: 'age',
        key: 'age',
        resizable: true,
        width: 100,
        minWidth: 100,
        maxWidth: 200,
    }
    */

    const props = __props;
    const tableColumns = ref([]);
    const displayColumns = computed(() => (tableColumns.value || []).filter(col => !!col.visible));
    const emit = __emit;
    const tableMaxWidth = ref(800); // 设计该项时，无数据会发生Uncaught runtime errors，原因未知
    const tableMaxHeight = ref(200);
    onMounted(() => {
      nextTick(() => {
        tableMaxWidth.value = containerRef.value.offsetWidth;
        tableMaxHeight.value = containerRef.value.offsetHeight - 150;
      });
    });
    const tableScrollOptions = computed(() => {
      return {
        y: tableMaxHeight.value
      };
    });
    const customRowHandler = (record, index) => {
      const handleRowClick = () => {
        emit('row-click', record, index);
      };
      const handleRowDblclick = () => {
        emit('row-dblclick', record, index);
      };
      const handleRowContextmenu = () => {
        emit('row-contextmenu', record, index);
      };
      const handleRowMouseenter = () => {
        emit('row-mouseenter', record, index);
      };
      const handleRowMouseleave = () => {
        emit('row-mouseleave', record, index);
      };
      return {
        // 点击行
        onClick: handleRowClick,
        onDblclick: handleRowDblclick,
        onContextmenu: handleRowContextmenu,
        // 鼠标移入行
        onMouseenter: handleRowMouseenter,
        onMouseleave: handleRowMouseleave
      };
    };
    const dragOldColIndex = ref(-1);
    const dragNewColIndex = ref(-1);
    const compareTableColumn = (a, b) => {
      if (a.dataIndex) {
        return getDataIndexKey(a.dataIndex) === getDataIndexKey(b.dataIndex);
      } else if (a.key) {
        return a.key === b.key;
      }
      return false;
    };
    const getColumnIndex = column => {
      const rows = tableColumns.value.slice();
      return rows.findIndex(cur => compareTableColumn(cur, column));
    };
    const customHeaderCell = column => {
      const handleHeaderCellDragStart = event => {
        const ev = event || window.Event;
        ev.stopPropagation();
        dragOldColIndex.value = getColumnIndex(column);
        dragNewColIndex.value = -1;
      };
      const handleHeaderCellDragover = event => {
        const ev = event || window.Event;
        ev.preventDefault();
        if (column.flex) return; // 不能拖动弹性列
        Object.assign(ev.dataTransfer, {
          dropEffect: 'move'
        });
        const newIndex = getColumnIndex(column);
        if (newIndex === -1 || newIndex === dragOldColIndex.value) return;
        dragNewColIndex.value = newIndex;
      };
      const handleHeaderCellDragend = event => {
        const ev = event || window.Event;
        ev.stopPropagation();
        if (dragNewColIndex.value === -1 || dragNewColIndex.value === dragOldColIndex.value) return;
        const newColumns = tableColumns.value.slice();
        const oldItem = newColumns.splice(dragOldColIndex.value, 1)[0];
        newColumns.splice(dragNewColIndex.value, 0, oldItem);
        dragOldColIndex.value = -1;
        dragNewColIndex.value = -1;
        tableColumns.value = newColumns;
        saveColumnsConfig(props.configKey, newColumns);
      };
      const handleHeaderCellSettingClick = () => {
        showConfig();
        !!column.onSetting && column.onSetting();
      };
      const calcHeaderCellDragHolder = () => {
        const curIndex = getColumnIndex(column);
        if (dragNewColIndex.value === -1 || dragNewColIndex.value !== curIndex || dragOldColIndex.value === dragNewColIndex.value) {
          return 'none';
        }
        if (dragNewColIndex.value < dragOldColIndex.value) {
          return 'left';
        }
        return 'right';
      };
      const handleHeaderCellOnClick = () => {
        !!column.onClick && column.onClick();
      };
      const handleHeaderCellOnDoubleClick = () => {
        !!column.onDoubleClick && column.onDoubleClick();
      };
      const handleHeaderCellMouseDown = () => {
        !!column.onMouseDown && column.onMouseDown();
      };
      const handleHeaderCellMouseUp = () => {
        !!column.onMouseUp && column.onMouseUp();
      };
      const handleHeaderCellMouseenter = () => {
        !!column.onMouseEnter && column.onMouseEnter();
      };
      const handleHeaderCellContextmenu = () => {
        !!column.onContextmenu && column.onContextmenu();
      };
      const handleHeaderCellMouseleave = () => {
        !!column.onMouseLeave && column.onMouseLeave();
      };
      return {
        draggable: true,
        onSettingClick: handleHeaderCellSettingClick,
        onDragstart: handleHeaderCellDragStart,
        onDragover: handleHeaderCellDragover,
        onDragend: handleHeaderCellDragend,
        onClick: handleHeaderCellOnClick,
        // 双击单元格
        onDoubleClick: handleHeaderCellOnDoubleClick,
        // 鼠标按下单元格
        onMouseDown: handleHeaderCellMouseDown,
        // 鼠标松开单元格
        onMouseUp: handleHeaderCellMouseUp,
        // 鼠标移入单元格
        onMouseenter: handleHeaderCellMouseenter,
        // 鼠标移出单元格
        onMouseleave: handleHeaderCellMouseleave,
        // 右键菜单
        onContextmenu: handleHeaderCellContextmenu,
        dataIndex: unref(column.dataIndex),
        get 'data-dragHolder'() {
          return calcHeaderCellDragHolder();
        }
      };
    };
    const showConfig = () => {
      showConfigModal.value = true;
    };
    const restoreConfig = () => {
      clearColumnsConfig(props.configKey);
      loadColumnsConfig(props.columns);
    };
    const loadColumnsConfig = defineColumns => {
      const columns = readColumnsConfig(props.configKey, defineColumns || []);
      tableColumns.value = columns.map(item => {
        return {
          ...item,
          customHeaderCell
        };
      });
    };
    const handleApplyConfig = () => {
      loadColumnsConfig(props.columns);
    };
    watch(() => props.columns, val => {
      loadColumnsConfig(val);
    }, {
      immediate: true,
      deep: true
    });
    const loadConfig = () => {
      loadColumnsConfig(props.columns);
    };
    __expose({
      loadConfig,
      showConfig,
      restoreConfig
    });
    const handleColumnResize = (w, col) => {
      const rows = tableColumns.value.slice();
      const idx = rows.findIndex(cur => compareTableColumn(cur, col));
      if (idx === -1 || Number.isNaN(w)) return;
      rows[idx].width = w;
      tableColumns.value = rows;
      saveColumnsConfig(props.configKey, rows);
    };
    return (_ctx, _cache) => {
      return _openBlock(), _createElementBlock("div", {
        ref_key: "containerRef",
        ref: containerRef,
        class: "x-table-container"
      }, [_createVNode(_unref(ATable), _mergeProps(_ctx.$attrs, {
        ref_key: "tableRef",
        ref: tableRef,
        "show-header": "",
        columns: displayColumns.value,
        bordered: true,
        sticky: false,
        tableLayout: "fixed",
        size: "small",
        scroll: tableScrollOptions.value,
        "custom-row": customRowHandler,
        onResizeColumn: handleColumnResize
      }), _createSlots({
        title: _withCtx(() => [_createElementVNode("a", {
          class: "title-btn",
          href: "javascript:void(0);",
          onClick: showConfig
        }, [_createVNode(_unref(SettingOutlined))]), _createElementVNode("a", {
          class: "title-btn",
          href: "javascript:void(0);",
          onClick: restoreConfig
        }, [_createVNode(_unref(ClearOutlined))])]),
        _: 2
      }, [_renderList(Object.keys(_ctx.$slots), key => {
        return {
          name: key,
          fn: _withCtx(scope => [_renderSlot(_ctx.$slots, key, _mergeProps({
            key: key
          }, scope))])
        };
      })]), 1040, ["columns", "scroll"]), _createVNode(TableColumnConfig, {
        "config-key": __props.configKey,
        columns: __props.columns,
        onApplyConfig: handleApplyConfig,
        open: showConfigModal.value,
        "onUpdate:open": _cache[0] || (_cache[0] = $event => showConfigModal.value = $event)
      }, null, 8, ["config-key", "columns", "open"])], 512);
    };
  }
});